import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_back-to-top",
  "use": "icon_back-to-top-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 32 32\" id=\"icon_back-to-top\"><path stroke=\"currentColor\" stroke-opacity=\".5\" d=\"M.5 31.4998V.5h31v31l-31-.0002Z\" /><path fill=\"currentColor\" d=\"M15.2812 22.4004v.5h1v-.5h-1Zm1 0 .0001-12.80001h-1l-.0001 12.80001h1Z\" /><path stroke=\"currentColor\" stroke-linecap=\"square\" d=\"m11.1953 14.1816 4.5818-4.58178 4.5818 4.58178\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol